/* eslint-disable */
import { mapActions } from 'vuex';
import { formMixin, validators } from '@/components/forms/mixin';
import loaderMixin from '@/mixins/loader';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  mixins: [
    formMixin,
    loaderMixin,
  ],
  validations: {
    fields: {
      email: validators.multipleEmails,
    },
  },
  data() {
    return {
      fields: {
        email: '',
      },
      successEmail: '',
    };
  },
  watch: {
    'fields.email'(value) {
      if (value) {
        this.successEmail = '';
      }
    },
  },
  computed: {
    shareUrl() {
      return window.location.origin;
    },
    shareText() {
      return `Hey, I'm playing @PredictIt and I think you should, too. You can make some money and have some fun picking political futures like election results and world events. Don’t miss out!`;
    },
    facebookShareUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareUrl)}`;
    },
    twitterShareUrl() {
      return `http://twitter.com/share?url=${encodeURIComponent(this.shareUrl)}&text=${encodeURIComponent(this.shareText)}`;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    ...mapActions('profile', ['sendInviteEmail']),
    onSend() {
      this.loaderAdd();
      this.sendInviteEmail(this.fields.email)
        .then(() => {
          this.loaderRemove();
          this.successEmail = this.fields.email.split(';').map(i => i.replace(' ', '')).join(', ');
          this.fields.email = '';
          this.$nextTick(() => { this.$v.$reset(); });
        })
        .catch(() => this.loaderRemove());
    },
    openShareDialog(url) {
      window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
    },
    onFacebookShare() {
      this.openShareDialog(this.facebookShareUrl);
    },
    onTwitterShare() {
      this.openShareDialog(this.twitterShareUrl);
    },
    onInfoClick() {
      this.setCurrentSmallPopup(MODALS.SMALL_SHARE_INVITE_INFO);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/social/share-invite-widget/share-invite-widget.js